export const environment = {
  production: true,
  advertisedRate: '4.6% (4.8% APR*)',
};
